import { render, staticRenderFns } from "./NotificationFilters.vue?vue&type=template&id=002553ca"
import script from "./NotificationFilters.vue?vue&type=script&lang=js"
export * from "./NotificationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports